<template>
  <Layout>
    <Card>
      <p slot="title">系统用户管理</p>
      <Button
        class="titleBtn"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
      >新增系统用户</Button
      >
      <div class="content">
        <el-table :data="tableData" style="   width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userId"
            label="用户ID"
            minWidth="140"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            minWidth="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            minWidth="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            minWidth="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            minWidth="110"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleIdList"
            label="角色列表"
            minWidth="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createUserId"
            label="createUserId"
            minWidth="180"
            align="center"
          ></el-table-column>
          <el-table-column align="center" minWidth="200" label="操作">
            <template slot-scope="scope">
              <span @click="refundClick(scope.row)">修改</span>
              <!--<span @click="deletes(scope.row)">删除</span>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pagenum"
          @current-change="handleCurrentChange"
          :total="total"
        />
      </div>
    </Card>

    <el-dialog title="系统用户信息" :visible.sync="revamp" minWidth="480px">
      <el-form :model="form" class="formCss">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" :label-width="formLabelWidth">
          <!--<Select-->
          <!--  v-model="form.roleIdList"-->
          <!--  class="search-input"-->
          <!--  placeholder="请选择用户角色"-->
          <!--  size="small"-->
          <!--  @change="handleRolesChange"-->
          <!---->
          <!--  <Option-->
          <!--    v-for="item in role"-->
          <!--    :key="item.value"-->
          <!--    :label="item.label"-->
          <!--    :value="item.value"-->
          <!--  ></option>-->
          <!--</Select>-->
          <el-select   class="search-input" v-model="form.roleIdList" size="small" @change="handleRolesChange" clearable placeholder="请选择角色">
            <el-option
              v-for="item in role"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
        </el-select>
          </el-form-item>
      <el-form-item label="机构/团队/咨询师" :label-width="formLabelWidth">
          <!--<Select-->
          <!--  v-model="form.teamIdList"-->
          <!--  class="search-input"-->
          <!--  :disabled="!form.roleIdList"-->
          <!--  :loading="teamsLoading"-->
          <!--  placeholder="请选择架构"-->
          <!--  size="small"-->
          <!---->
          <!--  <Option-->
          <!--    v-for="item in team"-->
          <!--    :key="item.value"-->
          <!--    :label="item.label"-->
          <!--    :value="item.value"-->
          <!--  />-->
          <!--</Select>-->
          <Select
            v-model="form.teamIdList"
            :loading="teamsLoading"
            :disabled="!form.roleIdList"
            placeholder="请选择架构"
            loading-text="正在加载团队信息..."
            no-data-text="暂无可用架构"
          >
            <Option
              v-for="item in team"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :title="item.label"
            />
          </Select>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.teamName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <Button @click="revamp = false">取 消</Button>
        <Button type="primary" @click="newlyyys(form)">确 定</Button>
      </div>
    </el-dialog>
  </Layout>
</template>

<script>
import { api } from "@/request/api";
export default {
  data() {
    return {

      total: 10,
      pagenum: 1,
      pagesize: 10,
      disabled: false,
      revamp: false,
      form: {
        username: "",
        email: "",
        mobile: "",
        password: "",
        status: 1,
        roleIdList:[],
        teamIdList:[],
        pid:0,
        teamName:""
      },
      formLabelWidth: "100px",
      tableData: [],
      role: [],
      roleIdList: "",
      team:[],
      teamIdList: "",
      teamsLoading:false,
      roleName:"",
    };
  },
  mounted() {
    // 初始化用户列表
    this.sysUserInquire();

    this.sysRoleInquire();

  },

  methods: {
    async sysRoleInquire() {
      this.role  = []; // 清空旧数据
      console.log('sysRole');
      let vm = this;
      let parameter = {
        page: vm.pagenum,
        pagesize: vm.pagesize,
      };
     await  api.sysRoleList(parameter).then((response) => {
        if (response.data.code === 0) {
          if (response.data.page.list.length > 0) {
            response.data.page.list.forEach((element) => {
                vm.role.push({
                  value: element.roleId,
                  label: element.roleName
                });
            });
          }
        }
      });

    },

    async handleRolesChange(e){
      try {
        this.teamsLoading  = true;
        this.team  = []; // 清空旧数据
        this.form.teamIdList  = ""; // 清空选中
        let parameter = {
          roleId: e,
        };
        await api.teamQuery(parameter).then((response) => {
          response = response.data;
          console.log(response);
          if (response.code === 0) {
            if (response.data.length > 0) {
              response.data.forEach((element) => {
                let labels = "";
                if(element.teamType === 0 ){
                  labels = "机构名：" +element.teamName
                }else if(element.teamType === 1 ){
                  labels = "机构-团队名：" +element.teamName
                }
                this.team.push({
                  value: element.id,
                  label: labels
                });
              });
            }
          }
        });
      } catch (error) {
        console.error('[ 级联加载] 异常:', error)
        this.$message.error(' 数据加载失败')
      } finally {
        this.teamsLoading = false;
      }




      },


    deletes(item) {
      //删除
      var that = this;
      this.$confirm("您确定要删除当前方案么?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          var parameter = {
            id: item.id,
          };
          api.yysdelete(parameter).then((response) => {
            if (response.data.code === 0) {
              that.$message({
                type: "success",
                message: "删除成功!",
              });
              that.yysInquire();
            } else {
              that.$message({
                type: "success",
                message: response.data.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    sysUserInquire() {
      console.log('sysUser');
      //列表
      let that = this;
      let parameter = {
        page: that.pagenum,
        pagesize: that.pagesize,
      };
      api.sysUserList(parameter).then((response) => {

        response = response.data;
        console.log(response);
        if (response.code === 0) {
          that.total = response.page.totalCount;
          that.tableData = response.page.list;
        }
      });
    },

    handleCurrentChange(cpage) {
      //分页切换
      this.pagenum = cpage;
      this.sysUserInquire();
    },
    //新增营养素
    newlyyys(item) {
      let that = this;
      let parameter = item;
      parameter.status= 1;
      parameter.roleIdList=[item.roleIdList];
      console.log(typeof item.teamIdList);
      parameter.pid = item.teamIdList.length<0?[]:[item.teamIdList];

      api.sysUserAdd(parameter).then((response) => {
        if (response.data.code === 0) {
          that.sysUserInquire();
          that.revamp = false;
        }
      });
    },
    //修改
    refundClick(item) {
      //修改
      this.revamp = true;
      var that = this;
      var parameter = {
        id: item.id,
      };
      api.yysdetail(parameter).then((response) => {
        if (response.data.code === 0) {
          that.form = response.data.nutrient;
          that.form.imgs = [ { url: response.data.nutrient.img }];
          if (response.data.nutrient.img) {
            that.uploadDisabled = true;
          }
          that.form.humanClassifyId = that.form.humanClassifyId.split(",");
          for (let i = 0; i < that.form.humanClassifyId.length; i++) {
            that.form.humanClassifyId[i] = Number(that.form.humanClassifyId[i]);
          }
        }
      });
    },
    addClick() {
      //新增
      this.revamp = true;
      this.uploadDisabled = false;
      this.form = {
        name: "",
        description: "",
        humanClassifyId: [],
        url: "",
        imgs: [],
      };
    },
  },
};
</script>
<style lang="less">
.formCss .el-checkbox-button {
  height: 22px;
  line-height: 22px;
  margin-left: 10px;
}
.formCss .el-form-item__label {
  line-height: 24px;
}
.formCss .el-radio-button__inner,
.formCss .el-radio-button:first-child .el-radio-button__inner,
.formCss .el-checkbox-button__inner,
.formCss .el-checkbox-button:first-child .el-checkbox-button__inner {
  border-radius: 2px !important;
  border: 1px solid #91d5ff;
  padding: 5px;
  font-size: 12px;
}
.formCss .el-upload--picture-card {
  width: 67px;
  height: 67px;
  line-height: 72px;
  background: rgba(6, 107, 168, 0.04);
  border-radius: 6px;
  border: 2px solid rgba(6, 107, 168, 0.2);
}
.formCss .hide .el-upload--picture-card {
  display: none;
}
.formCss .el-upload-list--picture-card {
  margin-left: 100px;
}
</style>
